import { CIMSModule, CIMSPage, Permission } from 'shared'
import { useProtectedMenuItem } from './useProtectedMenuItem'

export function useIssues() {
  return useProtectedMenuItem({
    module: CIMSModule.Issues,
    pages: [
      {
        page: CIMSPage.IssueTracker,
        permission: Permission.ViewIssue,
      },
      {
        page: CIMSPage.IssueTypes,
        permission: Permission.ViewIssueType,
      },
      {
        page: CIMSPage.IssueDispositionTypes,
        permission: Permission.ViewIssueDispositionType,
      },
      {
        page: CIMSPage.IssueQuickLinks,
        permission: Permission.ViewIssueQuickLink,
      },
      {
        page: CIMSPage.IssueNotifications,
        permission: Permission.ViewIssueNotification,
      },
    ],
  })
}
